const PageTitle = ({ children }) => (
    <h2 className="w-full text-center mt-2">{children}</h2>
  );
 
 export default PageTitle; 